module.exports = __webpack_public_path__ + "media/04_ASANBUDAPEST-Atmosphere04.0e362577.mp3";